import { render, staticRenderFns } from "./snackbar.vue?vue&type=template&id=025f4030&scoped=true"
import script from "./snackbar.vue?vue&type=script&lang=js"
export * from "./snackbar.vue?vue&type=script&lang=js"
import style0 from "./snackbar.vue?vue&type=style&index=0&id=025f4030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025f4030",
  null
  
)

export default component.exports